
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Header from "../components/common/Header";
import useTranslation from "next-translate/useTranslation";
import MainLayout from "../layouts/main";
import Footer from "../components/common/Footer";
import Banner from "../components/pages/ecosystem/mint/Banner";
import Features from "../components/pages/ecosystem/mint/Features";
import BusinessToken from "../components/pages/ecosystem/mint/BusinessToken";
import Faqs from "../components/common/Faqs";
const ColdwareMint = () => {
    const { t } = useTranslation();
    const faqs = t('coldware_mint:faqs', {}, { returnObjects: true });
    const seo = t('common:seo', {}, { returnObjects: true });
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.list.map(el => {
            return {
                "@type": "Question",
                "name": el.title,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": el.text.map(text => text)
                }
            };
        })
    };
    return (<MainLayout title={seo.coldware_mint.title} description={seo.coldware_mint.description} keywords={seo.coldware_mint.keywords} page={'mint'} alternate={'coldware-mint'} canonical={'/coldware-mint'} schemaData={schemaData}>
            <Header t={t}/>
            <main className='main'>
                <Banner t={t}/>
                <Features t={t}/>
                <BusinessToken t={t}/>
                <Faqs faqs={faqs}/>
            </main>
            <Footer t={t}/>
        </MainLayout>);
};
export default ColdwareMint;

    async function __Next_Translate__getStaticProps__1973b7664cb__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/coldware-mint',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1973b7664cb__ as getStaticProps }
  